<template>
  <div>
    <div class="title-h3 title-bar">구성 정보</div>
    <hr class="mr-b20" />
    <el-row v-loading="isLoading" type="flex" justify="space-betwwen" :gutter="20">
      <el-col :span="24">
        <el-row :gutter="20">
          <el-col :span="8">
            <!-- 기본정보 -->
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">기본 정보</div>
              <div class="list form-list">
                <el-form ref="configForm" :model="formData" label-width="140px" :rules="configRules">
                  <el-form-item label="장비명">
                    <w-text-form :modifiable="false" :target="formData" property="objName"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="IP 종류">
                    <w-text-form :modifiable="false" :target="formData" property="ipaddressApplytype"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="IPv4" prop="ipaddressIpv4">
                    <w-text-form :modifiable="false" :target="formData" property="ipaddressIpv4"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="IPv6" prop="ipaddressIpv6">
                    <w-text-form :modifiable="modifiable" :target="formData" property="ipaddressIpv6"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="서브넷마스크" prop="objSubnetmask">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objSubnetmask"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="MAC 주소" prop="objMacaddress">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objMacaddress"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="가상화 벤더">
                    <w-text-form :modifiable="false" :target="formData" property="basicinfoSubname"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="장비 종류">
                    <w-text-form :modifiable="false" :target="formData" property="objtypeName"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="제조업체">
                    <w-text-form :modifiable="false" :target="formData" property="VHO_SYSTEM/MANUFACTURING_FIRM"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="모델">
                    <w-text-form :modifiable="false" :target="formData" property="VHO_SYSTEM/MODEL_NAME"> </w-text-form>
                  </el-form-item>
                  <el-form-item v-if="formData.periodVhoBootTime" label="기동시각">
                    <w-text-form :modifiable="false" :target="formData" property="periodVhoBootTime"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="중요도">
                    <w-obj-importance-form-editor :modifiable="modifiable" :target="formData" property="objImportance"> </w-obj-importance-form-editor>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <!-- 장비 접속 설정 -->
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">장비 접속 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="접속 방법">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="connetTypeList" option-key="label" property="useSSH" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="Telnet Port">
                    <w-number-form :modifiable="modifiable" :target="formData" property="telnetPort"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="SSH Port">
                    <w-number-form :modifiable="modifiable" :target="formData" property="sshPort"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="1차 접속 ID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserId1"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="1차 패스워드">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserPw1" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="2차 접속 ID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserId2"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="2차 패스워드">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserPw2" type="password"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <!-- HW/SW 정보 -->
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">HW/SW 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="140px">
                  <el-form-item v-for="item in formItems" :key="item.label" :label="item.label">
                    <w-text-form :modifiable="false" :target="formData" :property="item.property"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">관리자/유지보수 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="관리자(정)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMajor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMajor) }} </span>
                  </el-form-item>
                  <el-form-item label="관리자(부)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMinor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMinor) }} </span>
                  </el-form-item>
                  <el-form-item label="유지보수 업체">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceCompany"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 담당자">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceManager"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 연락처">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceTel"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">Application Link 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="Link">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkWwwUrl"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Application">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkAppPath"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">이벤트 제외 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="이벤트 제외">
                    <w-check-form :modifiable="modifiable" :target="formData" property="eventExceptFlag"> </w-check-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep, isNil, isEmpty, assign } from 'lodash';
// for edit cmp
import WTextForm from '@/components/formeditor/TextFormEditor';
import WCheckForm from '@/components/formeditor/CheckFormEditor';
import WNumberForm from '@/components/formeditor/NumberFormEditor';
import WSelectForm from '@/components/formeditor/SelectFormEditor';
import { EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import perfApi from '@/api/virtual/performance/config';
import commonAPI from '@/api/config/common';
import MsgUtil from '@/utils/message';
import WObjImportanceFormEditor from '@/components/formeditor/ObjImportanceFormEditor';
import { calcUptime } from '@/utils/date';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';

const connetTypeList = [
  {
    label: 'SSH',
    useSSH: true,
  },
  {
    label: 'Telnet',
    useSSH: false,
  },
];
// VMWARE - VHO - HW/SW 정보
const VMWAREFormItems = [
  {
    label: '가상시스템 수',
    property: 'VHO_COMMON/VM_COUNT',
  },
  {
    label: '템플릿 수',
    property: 'VHO_COMMON/TEMPLATE_COUNT',
  },
  {
    label: 'CPU 코어',
    property: 'cpuCoreFormat',
  },
  {
    label: '프로세서 유형',
    property: 'VHO_PROCESSOR/PROCESSOR_TYPE',
  },
  {
    label: '프로세서 소켓 수',
    property: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT',
  },
  {
    label: '소켓당 코어 수',
    property: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET',
  },
  {
    label: '논리 프로세서 수',
    property: 'VHO_PROCESSOR/CPU_LOGICAL_PROCESSOR_COUNT',
  },
  {
    label: '하이퍼스레딩',
    property: 'VHO_PROCESSOR/HYPER_THREADING_MODE',
  },
  {
    label: '메모리 합계',
    property: 'VHO_MEM/TOTAL_CAPACITY',
  },
  {
    label: '시스템 메모리',
    property: 'VHO_MEM/SYSTEM_CAPACITY',
  },
  {
    label: '가상 시스템 메모리',
    property: 'VHO_MEM/VIRTUAL_SYSTEM_CAPACITY',
  },
  {
    label: 'NIC 수',
    property: 'VHO_NETWORK/NIC_COUNT',
  },
  {
    label: 'vMotion 사용여부',
    property: 'VHO_COMMON/VMOTION_MODE',
  },
  {
    label: 'Vmware EVC 모드',
    property: 'VHO_COMMON/EVC_MODE',
  },
  {
    label: 'vSphere HA 상태',
    property: 'VHO_COMMON/HA_STATE',
  },
  {
    label: 'Fault Tolerance 버전',
    property: 'VHO_COMMON/FAULT_TOLERANCE_VERSION',
  },
  {
    label: '라이센스',
    property: 'VHO_LICENSE/NAME',
  },
];
// KVM - VHO - HW/SW 정보
const KVMFormItems = [
  {
    label: '가상시스템 수',
    property: 'VHO_COMMON/VM_COUNT',
  },
  {
    label: 'CPU 코어 수',
    property: 'VHO_COMMON/CPU_CORE_TOTAL_COUNT',
  },
  {
    label: '프로세서 유형',
    property: 'VHO_PROCESSOR/PROCESSOR_TYPE',
  },
  {
    label: '프로세서 소켓 수',
    property: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT',
  },
  {
    label: '소켓당 코어 수',
    property: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET',
  },
  {
    label: '논리 프로세서 수',
    property: 'VHO_PROCESSOR/CPU_LOGICAL_PROCESSOR_COUNT',
  },
  {
    label: '시스템 메모리',
    property: 'VHO_MEM/SYSTEM_CAPACITY',
  },
];
// HYPERV - HW/SW 정보
const HYPERVFormItems = [
  {
    label: '가상시스템 수',
    property: 'VHO_COMMON/VM_COUNT',
  },
  {
    label: 'CPU 코어',
    property: 'cpuCoreFormat',
  },
  {
    label: '프로세서 유형',
    property: 'VHO_PROCESSOR/PROCESSOR_TYPE',
  },
  {
    label: '프로세서 소켓 수',
    property: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT',
  },
  {
    label: '소켓당 코어 수',
    property: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET',
  },
  {
    label: '논리 프로세서 수',
    property: 'VHO_PROCESSOR/CPU_LOGICAL_PROCESSOR_COUNT',
  },
  {
    label: '메모리 합계',
    property: 'VHO_MEM/TOTAL_CAPACITY',
  },
  {
    label: 'NIC 수',
    property: 'VHO_NETWORK/NIC_COUNT',
  },
  {
    label: '운영체제',
    property: 'VHO_COMMON/OS',
  },
  {
    label: '에이전트 버전',
    property: 'VHO_AGENT/VERSION',
  },
  {
    label: '에이전트 상태',
    property: 'VHO_AGENT/STATE',
  },
  {
    label: 'VMRC 상태',
    property: 'VHO_VMRC/STATE',
  },
  {
    label: 'VMRC 포트',
    property: 'VHO_VMRC/PORT',
  },
  {
    label: '안전 VMRC 상태',
    property: 'VHO_VMRC/SECURE_STATE',
  },
  {
    label: 'VMRC 인증 가능 여부',
    property: 'VHO_VMRC/CERTIFICATION_AVAILABILITY',
  },
  {
    label: '가상화 소프트웨어 버전',
    property: 'VHO_COMMON/SOFTWARE_VERSION',
  },
];
// XENSERVER - HW/SW 정보
const XENSERVERFormItems = [
  {
    label: '가상시스템 수',
    property: 'VHO_COMMON/VM_COUNT',
  },
  {
    label: '템플릿 수',
    property: 'VHO_COMMON/TEMPLATE_COUNT',
  },
  {
    label: 'CPU 코어',
    property: 'cpuCoreFormat',
  },
  {
    label: '프로세서 유형',
    property: 'VHO_PROCESSOR/PROCESSOR_TYPE',
  },
  {
    label: '프로세서 소켓 수',
    property: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT',
  },
  {
    label: '소켓당 코어 수',
    property: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET',
  },
  {
    label: '메모리 합계',
    property: 'VHO_MEM/TOTAL_CAPACITY',
  },
  {
    label: 'NIC 수',
    property: 'VHO_NETWORK/NIC_COUNT',
  },
  {
    label: '풀 마스터',
    property: 'VHO_COMMON/POOL_MASTER',
  },
  {
    label: 'XenServer 버전',
    property: 'VHO_COMMON/HYPERVISOR_VERSION',
  },
];
// RHEV - HW/SW 정보
const RHEVFormItems = [
  {
    label: '가상시스템 수',
    property: 'VHO_COMMON/VM_COUNT',
  },
  {
    label: 'CPU 코어',
    property: 'cpuCoreFormat',
  },
  {
    label: '프로세서 유형',
    property: 'VHO_PROCESSOR/PROCESSOR_TYPE',
  },
  {
    label: '프로세서 소켓 수',
    property: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT',
  },
  {
    label: '메모리 합계',
    property: 'VHO_MEM/TOTAL_CAPACITY',
  },
  {
    label: 'NIC 수',
    property: 'VHO_NETWORK/NIC_COUNT',
  },
  {
    label: 'kdump 상태',
    property: 'VHO_COMMON/KDUMP_STATE',
  },
  {
    label: 'SELinux 상태',
    property: 'VHO_COMMON/SELINUX_MODE',
  },
  {
    label: '새로운 가상 머신의 스케줄을 위한 최대 여유 메모리',
    property: 'VHO_COMMON/MAX_SCHEDULING_MEMORY',
  },
];

export default {
  name: 'WConfigStatus',
  components: {
    WTextForm,
    WCheckForm,
    WNumberForm,
    WSelectForm,
    WObjImportanceFormEditor,
  },
  props: {
    nodeParams: Object,
    activeTab: String,
  },
  computed: {
    ...mapGetters(['rejectConfigEditing', 'saveConfigEditing', 'configRules', 'selectedNode']),
    modifiable() {
      return this.$store.state.config.isConfigEditing;
    },
    params() {
      return {
        objId: this.nodeParams.objId,
        objtypeId: this.nodeParams.objtypeId,
      };
    },
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(tabName) {
        if (tabName === this.$options.name) {
          this.loadData();
        }
      },
    },
    params: {
      immediate: true,
      handler() {
        if (this.modifiable) {
          // 대상 변경 시 수정모드 종료
          this.$store.dispatch('setConfigEditing', false);
        }
        this.loadData();
      },
    },
    rejectConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.formData = Object.assign({}, this.formDataOrigin);
          this.$store.dispatch('initRejectConfig');
        }
      },
    },
    saveConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.$refs.configForm.validate((valid) => {
            if (valid) {
              this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.SAVE))
                .then(() => {
                  const formData = this.formData;
                  const infoParams = Object.assign({}, formData);
                  const modifiedData = formData.modified;

                  const updateDate = {
                    objId: infoParams.objId,
                    objName: infoParams.objName,
                    objImportance: formData.objImportance, // null이면 delete로 판단하므로 값 변경이 없을 경우에도 서버단에 전달한다.
                    objtypeId: this.params.objtypeId,
                  };
                  if (modifiedData && Object.keys(modifiedData).length > 0) {
                    Object.keys(modifiedData).forEach((key) => {
                      updateDate[key] = formData[key];
                    });
                  }
                  updateDate.objManagerIdMajor = formData.objManagerIdMajor;
                  updateDate.objManagerIdMinor = formData.objManagerIdMinor;

                  const target = '구성 정보';
                  const action = MsgUtil.action.SAVE;
                  const encryptTargetData = createEncryptTargetData(updateDate, ['telnetuserPw1', 'telnetuserPw2']);
                  if (encryptTargetData !== null) {
                    getRsaEncrypt(encryptTargetData)
                      .then((encryptData) => {
                        this.saveConfig(assign(updateDate, encryptData), action, target);
                      })
                      .catch((e) => {
                        this.$message(MsgUtil.getResultMsgData(action, target, false));
                        throw new Error(e);
                      });
                  } else {
                    this.saveConfig(updateDate, action, target);
                  }
                })
                .catch(() => {
                  this.$store.dispatch('setSaveConfigEditing', false);
                });
            } else {
              this.$store.dispatch('setSaveConfigEditing', false);
            }
          });
        }
      },
    },
  },
  data() {
    return {
      isLoading: true,
      connetTypeList,
      formData: {
        periodVhoBootTime: '',
        cpuCoreFormat: '',
      }, // Form 바인딩 데이터
      formDataOrigin: {},
      managerList: [],
      formItems: [],
    };
  },
  methods: {
    convertValuByUnit,
    loadData() {
      this.isLoading = true;
      if (this.selectedNode.hypervisorType === 'VMWARE') {
        this.formItems = VMWAREFormItems;
      } else if (this.selectedNode.hypervisorType === 'KVM') {
        this.formItems = KVMFormItems;
      } else if (this.selectedNode.hypervisorType === 'HYPERV') {
        this.formItems = HYPERVFormItems;
      } else if (this.selectedNode.hypervisorType === 'XENSERVER') {
        this.formItems = XENSERVERFormItems;
      } else if (this.selectedNode.hypervisorType === 'RHEV') {
        this.formItems = RHEVFormItems;
      }
      perfApi
        .getNodeConfigInfoForObjtype(this.params)
        .then((response) => {
          if (response.data.success && response.data.data.length > 0) {
            // 단위 변환 함수 (Byte)
            this.convertSizeForHW(response, 'VHO_MEM/TOTAL_CAPACITY', 'MB', 'B'); // 메모리 합계
            this.convertSizeForHW(response, 'VHO_MEM/VIRTUAL_SYSTEM_CAPACITY', 'MB', 'B'); // 가상 시스템 메모리
            this.convertSizeForHW(response, 'VHO_MEM/SYSTEM_CAPACITY', 'MB', 'B'); // 시스템 메모리
            this.convertSizeForHW(response, 'VHO_COMMON/MAX_SCHEDULING_MEMORY', 'MB', 'B'); // 스케줄링 메모리
            // 호스트 기동시각
            if (response.data.data[0]['VHO_COMMON/BOOT_TIME'] !== '') {
              response.data.data[0].periodVhoBootTime = `${response.data.data[0]['VHO_COMMON/BOOT_TIME']} (${calcUptime(new Date(response.data.data[0]['VHO_COMMON/BOOT_TIME']), new Date())})`;
            }
            // CPU 코어 수 포멧
            if (response.data.data[0]['VHO_COMMON/CPU_CORE_TOTAL_COUNT'] !== '' && response.data.data[0]['VHO_COMMON/CPU_CLOCK'] !== '') {
              response.data.data[0].cpuCoreFormat = `${response.data.data[0]['VHO_COMMON/CPU_CORE_TOTAL_COUNT']}개, CPU*${convertValuByUnit(Number(response.data.data[0]['VHO_COMMON/CPU_CLOCK']), 'MB', true, false, true)}hz`;
            }
            this.formDataOrigin = cloneDeep(response.data.data[0]);
            this.formData = cloneDeep(response.data.data[0]);
            this.$emit('setConfigData', this.formData);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
      commonAPI.getMgrInfoList({}).then((res) => {
        this.managerList = res.data.data;
      });
    },
    /**
     * 구성 정보를 저장한다.
     * @author Ju
     * @param  {[type]} data   [description]
     * @param  {[type]} action [description]
     * @param  {[type]} target [description]
     * @return {[type]}        [description]
     */
    saveConfig(data, action, target) {
      perfApi
        .updateVmsObjConfig(data)
        .then((result) => {
          if (result.data.success) {
            this.$message(MsgUtil.getResultMsgData(action, target, true));
            this.$store.dispatch('endConfigEdit');
            this.loadData();
          } else {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(action, target, true));
          throw new Error(e);
        });
    },
    // 단위변환
    convertSizeForHW(response, key, unit, unitTail) {
      response.data.data[0][key] = isNil(Number(response.data.data[0][key])) ? EMPTY_TEXT : `${convertValuByUnit(Number(response.data.data[0][key]), unit, true, false, true)}${unitTail}`;
    },
    /**
     * managerName 조회
     * @param  {[type]} managerId [description]
     * @return {[type]}           [description]
     * @author jda
     */
    getObjManagerName(managerId) {
      if (isEmpty(managerId)) {
        return EMPTY_TEXT;
      }
      const mgrInfo = this.managerList.find((data) => data.managerId === managerId);
      return isEmpty(mgrInfo) ? EMPTY_TEXT : mgrInfo.managerName;
    },
  },
};
</script>

<style>
.form-list .el-form-item__label {
  text-align: left;
}

.form-header {
  padding-left: 10px;
  height: 25px;
  font-weight: bold;
  font-size: 14px;
  color: #8b8b8b;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/virtual/host/configstatus/index.vue